export default __webpack_public_path__ + "static/media/korpa.61427fb1.png";